import APP_CONFIG from "../configs/environment";

export const FederatedLogoProductionProvider: any = APP_CONFIG.appSettingsData.federatedEngageAIProvider;

export const validationLimitValues = {
  brandNameMaxLength: 64,
};
